import React, { useRef, useEffect, useState } from "react";
import { withSidebar } from "../hoc/withSidebar";
import { useTranslation } from "react-i18next";
import ERPSBaseButton from "../custom/inputs/ERPSBaseButton";
import { useDispatch, useSelector } from "react-redux";
import Breadcrumb from "../Breadcrumb/Breadcrumb";
import ReactToPrint from "react-to-print";
import ComponentToPrint from "./ComponentToPrint";
import DialogHeader from "../custom/inputs/ERPSBaseModelDialog";
import actions from "../../actions";
import moment from "moment";
import domtoimage from "dom-to-image";
import {
  getFormatDetails,
  requiredFormatDate,
  formatAmount,
} from "../../utils/helper";
import ConfirmationMessage from "../custom/containers/ConfirmationMesssage";
import ErrorMessage from "../custom/containers/ErrorMessage";
import CommonContainerBox from "../custom/containers/CommonContainerBox";
import { transactionStatusMap }  from "../../constants/sharedConstants.js";
import { isShowBankCard } from "../../constants/TransactionEnquiryConstant";
import { Dialog, DialogActions, DialogContent, HStack, ResponsiveBox, Stack, Typography } from "../primitives";

const TransactionDetails = (props) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const {
    location: { state },
  } = props;
  
  const [openDialog, setDialogOpen] = useState({ isOpen: false });
  const [isRecallTrace, setRecallTrace] = useState(false);

  const transactionEnquiryData = useSelector(
    (state) => state.transactionEnquiryReducer?.transactionEnquiryData?.data
  );
  const successMessage = useSelector(
    (state) => state.transactionEnquiryReducer?.retraceRecallData
  );
  const errorMessage = useSelector(
    (state) => state.transactionEnquiryReducer?.retraceRecallError
  );
  const fiList = useSelector(
    (state) => state.fiReducer?.financialInstitutionList
  );
  const selectedFiNumber = useSelector((state) => state.fiReducer?.selectedFi);
  const user = useSelector((state) => state.loginUserReducer.user);
  const roleId = user?.role?.role_id;
  let componentRef = useRef();
  const errorRef = useRef();
  const successRef = useRef();

  useEffect(() => {
    dispatch({ type: "UPDATE_RECALL_RETRACE_INFO_SUCCESS", data: null });
    dispatch(actions.fiActions.getFinancialInstitutionList(t));
  }, []);

  useEffect(() => {
    if (errorRef.current) {
      errorRef.current.focus();
    }
  }, [errorMessage?.length]);

  let data = transactionEnquiryData
    ? transactionEnquiryData.find(({ payment_id }) => payment_id === state.id)
    : {};
  const fiNumberValue = selectedFiNumber ? selectedFiNumber : user?.fiNumber;
  const getBillerId = () => {
    return data?.display_biller_id;
  };
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);
  const [retraceLoading, setRetraceLoading] = useState(false);
  const [recallLoading, setRecallLoading] = useState(false);
  useEffect(() => {
    if (successRef.current) {
      successRef.current.focus();
    }
  }, [successMessage && showSuccessMessage]);

  useEffect(() => {
    if (fiList && Array.isArray(fiList)) {
      const rc_flag = fiList.find(
        (report) => report.fi_number == fiNumberValue
      )?.recall_trace_flag;

      // Buttons 'Recall' and 'Trace' are no longer shown in this screen - see FSCM-7421
      // if (rc_flag) {
      //   setRecallTrace(true);
      // }
    }
  }, [fiList]);

  const formatDateTime = (d) => {
    if (d) {
      return moment(d).format("YYYY-MM-DD hh:mm:ss:SS");
    } else {
      return "";
    }
  };

  const handleRecallAndRetrace = async (actionName) => {
    setDialogOpen( { isOpen: false, actionName: openDialog?.actionName });
    const setLoading =
      actionName === "trace" ? setRetraceLoading : setRecallLoading;
    setLoading(true);
    if (showSuccessMessage) {
      setShowSuccessMessage(false);
    }
    let reqBodyForAddRecallAndRetrace = {};
    if (data) {
      const {
        verification_number,
        payment_date,
        payment_time,
        biller_id,
        transaction_amount,
        fi_customer_name,
      } = data;
      const [date, time] = formatDateTime(new Date())?.split(" ");
      const initiatedDate = Number(date.replaceAll("-", ""));
      const initiatedTime = Number(time?.replaceAll(":", ""));
      reqBodyForAddRecallAndRetrace = {
        verification_number,
        payment_date,
        payment_time,
        biller_id,
        fi_number: selectedFiNumber || user?.fiNumber,
        transaction_amount,
        customer_name: fi_customer_name,
        request_status: "",
        requested_initiated_by: user?.userId,
        request_initiated_date: initiatedDate,
        request_initiated_time: initiatedTime,
        request_type: actionName === "trace" ? "T" : "R",
      };
    }
    const element = document.getElementById("screenshot-element");
    let blobData = await domtoimage.toBlob(element);
    // const canvas = await html2canvas(element);
    // const screenshotData = canvas.toDataURL("image/png");

    // const binaryString = atob(screenshotData.split(",")[1]);

    const reqBodyForSendEmail = {
      fiNumber: user?.fiNumber,
      clientName: data.fi_customer_name,
      userId: user?.userId,
      reqType: actionName === "trace" ? "T" : "R",
      screenshot: blobData,
      language: user?.languageCode,
    };

    // Buttons 'Recall' and 'Trace' are no longer shown in this screen - see FSCM-7421
    //  and function udpateRecallAndRetrace(..) has been removed.
    // dispatch(
    //   actions.transactionEnquiryActions.udpateRecallAndRetrace(
    //     { reqBodyForSendEmail, reqBodyForAddRecallAndRetrace },
    //     {
    //       setShowSuccessMessage,
    //       setLoading,
    //       t,
    //     }
    //   )
    // );
  };

  const handleOpenCancelDialog = (actionName) => {
    setDialogOpen({ isOpen: true, actionName });
  };

  const displayPaymentTime = (paymentTime) => {
    if (paymentTime) {
      const parsedPaymentTime = paymentTime.toString();
      const updatedPaymentTime = parsedPaymentTime.padStart(8, "0");
      return updatedPaymentTime.replace(/(..)(?!$)/g, "$1:");
    }
  };

  return (
    <div role="main">
      {successMessage && showSuccessMessage && (
        <ConfirmationMessage
          message={successMessage}
          setShowMessage={setShowSuccessMessage}
          inputRef={successRef}
        />
      )}
      <ErrorMessage 
        error={errorMessage}
        errorRef={errorRef}
        mt={2}
      />
      <ResponsiveBox ml={3}>
        <Breadcrumb
          {...props}
          componentAccess={state?.componentAccess}
          fromDetailPage={true}
        />
      </ResponsiveBox>

      <ResponsiveBox className="manageUsers__page__title" ml={3} mb={3}>
        {/* For Title update */}
        <CommonContainerBox
          title={t(
            "erps.transactionEnquiry.page.transactionDetails.page.heading"
          )}
        />
        <Typography variant="h1">
          {t("erps.transactionEnquiry.page.transactionDetails.page.heading")}
        </Typography>
      </ResponsiveBox>
      <ResponsiveBox id={"screenshot-element"} ml={3}>
        <ResponsiveBox mb={-2}>
          <Typography variant="h3">
            {t(
              "erps.transactionEnquiry.page.transactionDetails.page.subheading"
            )}
          </Typography>
        </ResponsiveBox>

        <ResponsiveBox mt={3} sx={{ display: "flex" }}>
          <Typography className="transaction__enquiry__value">
            {t("erps.common.label.effectiveDate")}
            <Typography variant="body2">
              {requiredFormatDate(data.effective_date_display_format)}
            </Typography>
          </Typography>
          <Typography className="transaction__enquiry__value left_space">
            {t(
              "erps.common.label.paymentDate/Time"
            )}
            <Typography variant="body2">
              {requiredFormatDate(data.payment_date_display_format) +
                " " +
                displayPaymentTime(data?.payment_time)?.substring(0, 8)}
            </Typography>
          </Typography>
          <Typography
            variant="label"
            className="transaction__enquiry__value left_space"
          >
            {t("erps.common.label.deliveryDate")}
            <Typography variant="body2">
              {requiredFormatDate(data.delivery_date_display_format)}
            </Typography>
          </Typography>
        </ResponsiveBox>

        <ResponsiveBox mt={3} sx={{ display: "flex" }}>
          <Typography className="transaction__enquiry__value">
            {t("erps.common.label.paymentAmount")}
            <Typography variant="body2">
              {formatAmount(data.transaction_amount)}
            </Typography>
          </Typography>
          <Typography className="transaction__enquiry__value left_space">
            {t(
              "erps.common.label.confirmationNumber"
            )}
            <Typography variant="body2">{data.verification_number}</Typography>
          </Typography>
          <Typography
            variant="label"
            className="transaction__enquiry__value left_space"
          >
            {t("erps.common.label.auditNumber")}
            <Typography variant="body2">{data.biller_file_number}</Typography>
          </Typography>
        </ResponsiveBox>

        <ResponsiveBox mt={3} sx={{ display: "flex" }}>
          <Typography className="transaction__enquiry__value">
            {t(
              "erps.common.label.transactionOrigination"
            )}
            <Typography variant="body2">{`${data?.cap_type || ""} ${
              data.caption_type_description || ""
            }`}</Typography>
          </Typography>
          <Typography className="transaction__enquiry__value left_space">
              {t("erps.common.label.status")}
              <Typography variant="body2">
                { t(transactionStatusMap.get(data?.transaction_status), data?.transaction_status) }
              </Typography>
            </Typography>
        </ResponsiveBox>

        <ResponsiveBox mt={4}>
          <Typography variant="h3">
            {t(
            "erps.common.label.billerDetails"
            )}
          </Typography>
        </ResponsiveBox>

        <ResponsiveBox mt={3} sx={{ display: "flex" }}>
          <Typography className="transaction__enquiry__value">
            {t(
              "erps.common.label.corporateBiller"
            )}
            <Typography variant="body2">
              {data.biller_name} <br />
              {t("erps.common.label.attention")} {data.primary_contact_name}{" "}
              <br />
              {t("erps.common.label.telephone")}{" "}
              {getFormatDetails(data.primary_contact_phone)} <br />
              {t("erps.common.label.fax")}{" "}
              {getFormatDetails(data.primary_contact_fax)} <br />
            </Typography>
          </Typography>
          <Typography className="transaction__enquiry__value left_space">
            {t(
              "erps.common.label.billerID"
            )}
            <Typography variant="body2">{getBillerId()}</Typography>
          </Typography>
        </ResponsiveBox>

        <ResponsiveBox mt={4}>
          <Typography variant="h3">
            {t(
              "erps.common.label.customerDetails"
            )}
          </Typography>
        </ResponsiveBox>

        <ResponsiveBox mt={3} sx={{ display: "flex" }}>
          {" "}
          <Typography className="transaction__enquiry__value">
            {t(
              "erps.common.label.customerAccountNumber"
            )}
            <Typography variant="body2">
              {data.biller_customer_number}
            </Typography>
          </Typography>
          <Typography className="transaction__enquiry__value left_space">
            {t(
              "erps.common.label.customerName"
            )}
            <Typography variant="body2">{data.fi_customer_name}</Typography>
          </Typography>
          {isShowBankCard(roleId, fiNumberValue) && (
            <Typography
              variant="label"
              className="transaction__enquiry__value left_space"
            >
              {t("erps.transactionEnquiry.componentToPrint.customerDetails.label.bankCardNumber")}
              <Typography variant="body2">
                {data.fiCustomerNumberStr}
              </Typography>
            </Typography>
          )}
        </ResponsiveBox>
      </ResponsiveBox>
      <HStack spacing={2} ml={3}>
        <ERPSBaseButton
          variant="secondary"
          className="button_with_margin48"
          label={t("erps.newuser.button.back", "Back")}
          onClick={() =>
            props.history.push("/review-transactions-old/", {
              componentAccess: state?.componentAccess,
              fromDetailPage: true,
            })
          }
        />
        <div>
          {/* button to trigger printing of target component */}
          <ReactToPrint
            trigger={() => (
              <ERPSBaseButton
                //functionType="NU"
                variant="primary"
                onClick={() => {}}
                className="button_with_margin48"
                label={t(
                  "erps.transactionEnquiry.page.transactionDetails.button.print"
                )}
              />
            )}
            content={() => componentRef}
          />

          {/* component to be printed */}
          <div style={{ display: "none" }}>
            <ComponentToPrint
              translation={t}
              ref={(el) => (componentRef = el)}
              data={data}
              fiNumberValue={fiNumberValue}
              roleId={roleId}
            />
          </div>
        </div>
        {isRecallTrace && (
          <>
            <ERPSBaseButton
              variant="secondary"
              className="button_with_margin48"
              label={t(
                "erps.transactionEnquiry.page.transactionDetails.button.recall"
              )}
              onClick={() => {
                handleOpenCancelDialog("recall");
              }}
              loading={recallLoading}
              actionType={"hasCallAuditBtnAccess"}
              componentAccess={state?.componentAccess}
            />
            <ERPSBaseButton
              variant="secondary"
              className="button_with_margin48"
              label={t(
                "erps.transactionEnquiry.page.transactionDetails.button.trace"
              )}
              onClick={() => {
                handleOpenCancelDialog("trace");
              }}
              loading={retraceLoading}
              actionType={"hasTraceAuditBtnAccess"}
              componentAccess={state?.componentAccess}
            />
          </>
        )}
      </HStack>

      <Dialog
        open={openDialog?.isOpen}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth={true}
      >
        <DialogHeader
          id="alert-dialog-title"
          onClose={() => {
            setDialogOpen({
              isOpen: false,
              actionName: openDialog?.actionName,
            });
          }}
          className={"box-dialog-header"}
        >
          {openDialog?.actionName && openDialog.actionName === "recall"
            ? t("erps.transactionEnquiry.page.transactionDetails.button.recall")
            : t("erps.transactionEnquiry.page.transactionDetails.button.trace")}
        </DialogHeader>
        <DialogContent
          id="alert-dialog-description"
          className={"cancel-dialog-content-size"}
        >
          {t("erps.transactionEnquiry.page.transactionDetails.dialog.content", {
            actionName: openDialog?.actionName,
          })}
        </DialogContent>
        <DialogActions className={"box-dialog-buttons"}>
          <ERPSBaseButton
            variant="secondary"
            className="button_with_zeromargin"
            onClick={() => {
              setDialogOpen({
                isOpen: false,
                actionName: openDialog?.actionName,
              });
            }}
            label={t("erps.common.button.cancel")}
          />
          <ERPSBaseButton
            variant="primary"
            className="button_with_zeromargin"
            onClick={() => handleRecallAndRetrace(openDialog?.actionName)}
            label={"Confirm"}
          />
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default withSidebar(TransactionDetails);
